import React from 'react';

const Admin = () => {
    return (
        <div>
            <h1>Admin Dashboard</h1>
            <p>Welcome to the admin panel. Here you can manage users, view reports, and configure settings.</p>
        </div>
    );
};

export default Admin;